import type { ReactNode } from 'react';
import { Button, ErrorText } from './ui';
import { Modal } from './modal';

/**
 * Asks before a change that matters (a role, a removal, letting someone in).
 * The buttons fill the width on phones; the error, if the change fails, shows
 * in the dialog so it stays open to try again or cancel.
 */
export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  danger,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  /** Red confirm button, for removals and declines. */
  danger?: boolean;
  busy?: boolean;
  error?: unknown;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal title={title} onClose={onClose}>
      <div className="space-y-3 text-sm text-muted-foreground">{children}</div>
      <div className="mt-3">
        <ErrorText error={error} />
      </div>
      <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button variant="secondary" className="w-full sm:w-auto" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={danger ? 'danger' : 'primary'}
          className="w-full sm:w-auto"
          disabled={busy}
          onClick={onConfirm}
        >
          {busy ? 'Working…' : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
